// extracted by mini-css-extract-plugin
export default {"DeleteButton":"DeleteButton_DeleteButton__uLO4p","Title":"DeleteButton_Title__VaxHQ","Lg":"DeleteButton_Lg__SIimx","Md":"DeleteButton_Md__BxMDl","Sm":"DeleteButton_Sm__q2mkT"};